import { render, staticRenderFns } from "./IcoSiniestro.vue?vue&type=template&id=3d61afc8&scoped=true"
import script from "./IcoSiniestro.vue?vue&type=script&lang=ts"
export * from "./IcoSiniestro.vue?vue&type=script&lang=ts"
import style0 from "./IcoSiniestro.vue?vue&type=style&index=0&id=3d61afc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61afc8",
  null
  
)

export default component.exports